<template>
    <div class="sportsbook">
        <form @submit.prevent="search" class="main-form">
            <custom-input v-model="userName" :title="$t('SPORTSBOOK_BETS__USERNAME')" @clear="userName = ''" />
            <custom-input v-model="betID" :title="$t('SPORTSBOOK_BETS__BET_ID')" @clear="betID = ''" />
            <button class="btn">{{ $t('SPORTSBOOK_BETS__SEARCH') }}</button>
        </form>
        <iframe :src="src" v-show="src"></iframe>
        <custom-snackbar
            :text="message.text"
            :purpose="message.purpose"
            v-if="message.visible"
            @close="message.visible = false"
        />
    </div>
</template>

<script>
import axios from '@/Helpers/AxiosInstance.js'
import CustomInput from '@/components/ReusableComponents/CustomInput/CustomInput.vue'
import CustomSnackbar from '@/components/ReusableComponents/CustomSnackbar/CustomSnackbar.vue'
export default {
    components: {
        CustomInput,
        CustomSnackbar,
    },
    created() {
        this.betID = this.$route.params.betID || ''
        this.cardID = this.$route.params.cardID
        if (this.cardID) {
            axios
                .get('WebShop/GetSportsBookJWTToken', {
                    params: {
                        accountCardId: this.cardID,
                    },
                })
                .then(resp => this.loadIFrame(resp))
        }
    },
    data() {
        return {
            message: {
                text: 'Cannot Load The Sportsbook. Check Inputs!',
                purpose: 'error',
                visible: false,
            },
            betID: '',
            cardID: '',
            src: '',
            userName: '',
        }
    },
    methods: {
        search() {
            axios
                .get('WebShop/GetSportsBookJWTToken', {
                    params: {
                        userName: this.userName,
                    },
                })
                .then(resp => {
                    this.loadIFrame(resp)
                })
                .catch(() => {
                    this.message.visible = true
                })
        },
        loadIFrame(resp) {
            let token = resp.data.token.response
            this.src = `https://sport.inplaynet.tech/admin/html/iframe_tickets.html?jwttoken=${token}&ticket=${this.betID}&filters=0&showpayout=true`
        },
    },
}
</script>

<style scoped lang="scss">
form {
    margin-bottom: 15 * $rem;
}
iframe {
    width: 100%;
    height: calc(100vh - #{151 * $rem});
}
</style>
